import { ApplicationConfig, InjectionToken, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter,withInMemoryScrolling , withRouterConfig } from '@angular/router';
import { environment } from '../environments/environment';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { loadingInterceptor } from './loading.interceptor';
import { observationReferenceRangeInterceptor } from './shared/observation-reference-range.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAuth0 } from '@auth0/auth0-angular';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { authInterceptor } from './shared/auth/auth.interceptor';
import { terminologyInterceptor } from './shared/terminology.interceptor';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getDatabase, provideDatabase } from '@angular/fire/database';
import { provideMarkdown } from 'ngx-markdown';
import { MatNativeDateModule } from '@angular/material/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
// to be reverted to later
const firebaseConfig = {
  apiKey: "AIzaSyByyamc31vpaP51jHRE-tLZHaOnIEwJat8",
  authDomain: "elikita2health.firebaseapp.com",
  databaseURL: "https://elikita2health-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "elikita2health",
  storageBucket: "elikita2health.firebasestorage.app",
  messagingSenderId: "463229094989",
  appId: "1:463229094989:web:6dc06de18854a5302fe004",
  measurementId: "G-48C8N08PY5"
};


// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyCTI4nOJ7ttdL_MF6Sda3JjXKFUqRgvfW0",
//   authDomain: "elikita3health.firebaseapp.com",
//   databaseURL: "https://elikita3health-default-rtdb.europe-west1.firebasedatabase.app",
//   projectId: "elikita3health",
//   storageBucket: "elikita3health.firebasestorage.app",
//   messagingSenderId: "921585025907",
//   appId: "1:921585025907:web:0c185eedb75d7a386a3b06",
//   measurementId: "G-1SNBJKVBFR"
// };



//upstream token from environment variable
export const upstreamServerEndPointToken = new InjectionToken<string>('upstream server api base url');


export const frontendUrlToken = new InjectionToken('base url on the frontend for resources')
export const backendUrlforSamplesToken = new InjectionToken<string>('backend url used for fetching sample data for this frontend');
export const backendUrlforSamplesValue = 'https://elikita-server.daalitech.com'
export const backendUrlforSamplesToken2 = new InjectionToken<string>('backend-2 url used for fetching sample data for this frontend');
export const backendUrlforSamplesValue2 = 'https://elikita-server.daalitech.com'

export const credentialsForWhoIcdToken = {
  clientId: '1efa091f-7148-4968-ba32-2a61dda9e6ae_281b0c51-d350-4646-b973-fada8f7ddd2b',
  clientSecret: 'dMkeOwQKq035oR2o7U2hVh1/jlms0lUvPCz5CfGEIAM='
}

//token for credentials
export const whoIcdCredentialsToken = new InjectionToken<{ clientId: string, clientSecret: string }>('who icd credentials token');
export const whoIcdCredentialsValue = credentialsForWhoIcdToken;

const auth0key = 'KF5ZXYGQFBXSPRAPU6Y9ACRV';
//export const backendEndPointToken = new InjectionToken<string>('backend api base url');
// export const backendEndPointValue = "https://elikita-server.daalitech.com"
// export const backendEndPointValue = "https://hapi.fhir.org/baseR4"
// export const backendEndPointValue = `https://fhir-open.cerner.com/r4/ec2458f2-1e24-41c8-b71b-0e701af7583d`;
// export const backendEndPointValue = `https://sandbox-r4.interopengine.com/fhir/r4/imedemrhttps://fhirsandbox.prognocis.com/prognocis/fhir/fhirsandbox`;
// export const backendEndPointValue = `https://lforms-fhir.nlm.nih.gov/baseR4`;
//export const backendEndPointValue = "https://server.fire.ly/r4"
// export const backendEndPointValue = "https://hapi.fhir.org/baseR4"

// FHIR Server endpoint (existing -for backward compatibility)
export const backendEndPointToken = new InjectionToken<string>('backend api base url');
 // export const backendEndPointValue = "http://localhost:5289/fhir"; //http://localhost:5289/fhir" //"https://elikita-server.daalitech.com"
// export const backendEndPointValue = "https://dev-auth-server-fmd4dthndrhjdzf2.canadacentral-01.azurewebsites.net/fhir"
 export const backendEndPointValue = environment.backendEndPoint;

// Patient-facing FHIR gateway endpoint (used when a logged-in Patient is fetching
// patient-scoped resources like Appointment/Slot/Schedule).
// Default is the same as backendEndPointValue, but you can override it per env.
export const patientBackendEndPointToken = new InjectionToken<string>('patient backend api base url');
export const patientBackendEndPointValue = environment.patientBackendEndPoint;
// Messaging Firebase root (optional) — read from environment
export const messagingFirebaseRootToken = new InjectionToken<string>('messaging firebase root');
export const messagingFirebaseRootValue = environment.messagingFirebaseRoot ?? '';
// export const patientBackendEndPointValue = "https://elikita-nodejs-server-atbsamercseeg2g4.brazilsouth-01.azurewebsites.net/"
// Canonical base URL for your custom terminology artifacts (CodeSystem.url / ValueSet.url).
// This is intentionally decoupled from backendEndPointValue so you can move servers
// without breaking canonical URL lookups like: GET [server]/ValueSet?url=[canonical].
export const terminologyCanonicalUrlBaseToken = new InjectionToken<string>('terminology canonical url base');
//export const terminologyCanonicalUrlBaseValue = backendEndPointValue;
export const terminologyCanonicalUrlBaseValue = 'https://elikita-server.daalitech.com';
export const patientSignatureExtensionUrlToken = new InjectionToken<string>('patient signature extension url');
export const patientSignatureExtensionUrlValue = `${terminologyCanonicalUrlBaseValue}/StructureDefinition/patient-signature`;
export const practitionerSignatureExtensionUrlToken = new InjectionToken<string>('practitioner signature extension url');
export const practitionerSignatureExtensionUrlValue = `${terminologyCanonicalUrlBaseValue}/StructureDefinition/practitioner-signature`;
// NEW: Auth Backend endpoint (C# .NET backend)
export const authBackendEndPointToken = new InjectionToken<string>('auth backend api base url');
//export const authBackendEndPointValue = "http://localhost:5289"; // Development
// export const authBackendEndPointValue = "https://dev-auth-server-fmd4dthndrhjdzf2.canadacentral-01.azurewebsites.net"; // Development
// export const authBackendEndPointValue = "https://dev-elikita-auth-server-b4fdafe0feh3gecg.canadacentral-01.azurewebsites.net"; // Development
 export const authBackendEndPointValue = environment.authBackendEndPoint;

export const hardCodedCodeableConceptOptions = {
  'identifier.type': [
    {
      code: 'tin-ng-others',
      display: 'Tax Identification Number',
      system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/identifier-type`
    },
    {
      code: 'nin-ng-others',
      display: 'National Identification Number',
      system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/identifier-type`
    },
    {
      code: 'nhis-ng-others',
      display: 'National Health Insurance Scheme',
      system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/identifier-type`
    },
    {
      code: 'driver-license-ng-others',
      display: 'Driver License',
      system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/identifier-type`
    },
    {
      code: 'voters-id-ng-others',
      display: 'Voter\'s ID',
      system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/identifier-type`
    }
  ]
}

export const serviceRequestCategoriesToken = new InjectionToken<Array<{ code: string, display: string, system: string }>>('service request categories');
export const serviceRequestCategoriesValue = [
  { code: 'laboratory', display: 'Laboratory', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/ServiceRequest/ServiceRequestCategories` },
  { code: 'imaging', display: 'Imaging', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/ServiceRequest/ServiceRequestCategories` },
  { code: 'observation', display: 'Observation', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/ServiceRequest/ServiceRequestCategories` },
  { code: 'procedure', display: 'Procedure', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/ServiceRequest/ServiceRequestCategories` },
  { code: 'consultation', display: 'Consultation', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/ServiceRequest/ServiceRequestCategories` },
  { code: 'cardiology', display: 'Cardiology', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/ServiceRequest/ServiceRequestCategories` },
  { code: 'pathology', display: 'Pathology', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/ServiceRequest/ServiceRequestCategories` },
  // { code: 'radiology', display: 'Radiology', system: 'https://elikita-server.daalitech.com/CodeSystem/ServiceRequest/ServiceRequestCategories' },
  { code: 'surgery', display: 'Surgery', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/ServiceRequest/ServiceRequestCategories` },
  { code: 'therapy', display: 'Therapy', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/ServiceRequest/ServiceRequestCategories` }
];

// Hard-coded SubstanceCode categories (FHIR CodeSystem/ValueSet are created in postman.substanceCode.transaction.json)
// NOTE: intentionally excludes "drug" / medication (handled elsewhere in the app).
export const substanceCodeCategoriesToken = new InjectionToken<Array<{ code: string; display: string; description: string; system: string }>>(
  'substance code categories'
);

export const substanceCodeCategoriesValue = [
  {
    code: 'allergen',
    display: 'Allergen',
    description: 'A substance that causes an allergic reaction.',
    system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/Substance/SubstanceCategory`
  },
  {
    code: 'biological',
    display: 'Biological Substance',
    description: 'A substance that is produced by or extracted from a biological source.',
    system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/Substance/SubstanceCategory`
  },
  {
    code: 'body',
    display: 'Body Substance',
    description: 'A substance that comes directly from a human or an animal (e.g. blood, urine, feces, tears, etc.).',
    system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/Substance/SubstanceCategory`
  },
  {
    code: 'chemical',
    display: 'Chemical',
    description: 'Any organic or inorganic substance of a particular molecular identity, including combinations occurring as a result of a chemical reaction or occurring in nature, and any element or uncombined radical.',
    system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/Substance/SubstanceCategory`
  },
  {
    code: 'food',
    display: 'Dietary Substance',
    description: 'A food, dietary ingredient, or dietary supplement for human or animal.',
    system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/Substance/SubstanceCategory`
  },
  {
    code: 'material',
    display: 'Material',
    description: 'A finished product which is not normally ingested, absorbed or injected (e.g. steel, iron, wood, plastic and paper).',
    system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/Substance/SubstanceCategory`
  }
];

export const specialtiesToken = new InjectionToken<Array<{ code: string, display: string, system: string }>>('specialties');
export const specialtiesValue = [
  { code: 'general-practice', display: 'General Practice', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'family-medicine', display: 'Family Medicine', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'internal-medicine', display: 'Internal Medicine', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'pediatrics', display: 'Pediatrics', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'obstetrics-gynecology', display: 'Obstetrics and Gynecology', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'general-surgery', display: 'General Surgery', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'orthopedics', display: 'Orthopedics', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'ophthalmology', display: 'Ophthalmology', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'ent', display: 'ENT (Otolaryngology)', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'psychiatry', display: 'Psychiatry', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'cardiology', display: 'Cardiology', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'neurology', display: 'Neurology', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'dermatology', display: 'Dermatology', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'urology', display: 'Urology', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'radiology', display: 'Radiology', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'anesthesiology', display: 'Anesthesiology', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'pathology', display: 'Pathology', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'dentistry', display: 'Dentistry', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'public-health', display: 'Public Health', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'gastroenterology', display: 'Gastroenterology', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'endocrinology', display: 'Endocrinology', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'nephrology', display: 'Nephrology', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'hematology', display: 'Hematology', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'oncology', display: 'Oncology', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` },
  { code: 'physiotherapy', display: 'Physiotherapy', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/specialties` }
];

export const appointmentTypesToken = new InjectionToken<Array<{ code: string, display: string, system: string, defaultDurationMinutes?: number }>>('appointment types');
export const appointmentTypesValue = [
  { code: 'outpatient-consultation', display: 'Outpatient Consultation', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/appointment-type`, defaultDurationMinutes: 15 },
  { code: 'ward-round', display: 'Ward Round', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/appointment-type`, defaultDurationMinutes: 120 },
  { code: 'antenatal', display: 'Antenatal Visit', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/appointment-type`, defaultDurationMinutes: 30 },
  { code: 'immunization', display: 'Immunization', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/appointment-type`, defaultDurationMinutes: 15 },
  { code: 'surgery', display: 'Surgery', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/appointment-type`, defaultDurationMinutes: 120 },
  { code: 'emergency', display: 'Emergency', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/appointment-type`, defaultDurationMinutes: 30 },
  { code: 'medical-checkup', display: 'Medical Checkup', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/appointment-type`, defaultDurationMinutes: 30 },
  { code: 'field-event', display: 'Field Event', system: `${terminologyCanonicalUrlBaseValue}/CodeSystem/appointment-type`, defaultDurationMinutes: 60 }
];

export const fhirDefaultCountToken = new InjectionToken<number>('default count for FHIR GET requests');
export const fhirDefaultCountValue = 50;

// When a FHIR server does not include Bundle.link[relation="next"] but Bundle.total indicates
// more results exist, the app-wrapper resolver can fall back to a single "fetch all" request.
// This cap prevents huge downloads that could freeze the UI.
export const fhirMaxAllAtOnceCountToken = new InjectionToken<number>('max _count for all-at-once fallback fetches');
export const fhirMaxAllAtOnceCountValue = 50;

// export const hardCodedHospitalId = '45bbd0a2-815b-4549-aff3-b2e66372a7a8'
//hapi.fhir.org dummy's
export const hardCodedHospitalId = 'AtEmedExampleOrganizationApo01' //hpi's
// export const hardCodedHospitalId = '14d5f5b1-4e49-4f41-9c49-0b62f3736257' //lforms
export const frontendUrlValue = "/app"

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimationsAsync(),
    // provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' }),withInMemoryScrolling({
  //   anchorScrolling: 'enabled',
  //   scrollPositionRestoration: 'enabled',
  // })),
    importProvidersFrom(MatSnackBarModule),
    provideMarkdown(),
    // provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })),
    importProvidersFrom(
      MatSnackBarModule,
      MatNativeDateModule,
      CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: adapterFactory,
      })
    ),

    // ✅ FIXED: Combine both interceptors in ONE provideHttpClient using wrappers to prevent circular dependency evaluation errors
    provideHttpClient(
      withFetch(),
      withInterceptors([
        (req, next) => terminologyInterceptor(req, next),
        (req, next) => authInterceptor(req, next),
        (req, next) => loadingInterceptor(req, next), (req, next) => observationReferenceRangeInterceptor(req, next)
      ])
    ),
    { provide: upstreamServerEndPointToken, useValue: environment.upstreamServerEndPoint },
    { provide: backendEndPointToken, useValue: backendEndPointValue },

    { provide: patientBackendEndPointToken, useValue: patientBackendEndPointValue },
    { provide: messagingFirebaseRootToken, useValue: messagingFirebaseRootValue },
    { provide: terminologyCanonicalUrlBaseToken, useValue: terminologyCanonicalUrlBaseValue },
    { provide: patientSignatureExtensionUrlToken, useValue: patientSignatureExtensionUrlValue },
    { provide: practitionerSignatureExtensionUrlToken, useValue: practitionerSignatureExtensionUrlValue },
    { provide: authBackendEndPointToken, useValue: authBackendEndPointValue },
    { provide: whoIcdCredentialsToken, useValue: whoIcdCredentialsValue },

    { provide: DateAdapter, useFactory: adapterFactory },
    provideAuth0({
      clientId: 'z98t79nSLDRtcCAQLxIvciQDaQoJrKki',
      domain: 'dev-pwmm50kju0rcf8hi.us.auth0.com',
      authorizationParams: {
        redirect_uri: window.location.origin + "/auth/callback"
      }
    }),
    { provide: frontendUrlToken, useValue: frontendUrlValue },
    { provide: backendUrlforSamplesToken, useValue: backendUrlforSamplesValue },
    { provide: backendUrlforSamplesToken2, useValue: backendUrlforSamplesValue2 },
    { provide: serviceRequestCategoriesToken, useValue: serviceRequestCategoriesValue },
    { provide: substanceCodeCategoriesToken, useValue: substanceCodeCategoriesValue },
    { provide: specialtiesToken, useValue: specialtiesValue },
    { provide: appointmentTypesToken, useValue: appointmentTypesValue },
    { provide: fhirDefaultCountToken, useValue: fhirDefaultCountValue },
    { provide: fhirMaxAllAtOnceCountToken, useValue: fhirMaxAllAtOnceCountValue },
    { provide: whoIcdCredentialsToken, useValue: whoIcdCredentialsValue },
    provideFirebaseApp(() => initializeApp(firebaseConfig)),
    provideAuth(() => getAuth()),
    provideDatabase(() => getDatabase()),
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { maxHeight: '93vh' }
    }
  ]
};

// 8$HHxL8ah2qZ sid@sid.com -. patient login

// -------------------------------
// Pracititioner logins (all have same password: DaV$smD3$@gk):

// Email: focejed481@bultoc.com

// Temporary Password: DaV$smD3$@gk

// .....................................
